import { useNavigate } from "react-router-dom";
import Aside from "../../../components/Aside";
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";
import { useMemo, useState } from "react";
import Step1Partial from "./Step1Partial";
import Step2Partial from "./Step2Partial";
import { MetaService } from "../../../services/MetaService";
import { useCurrentAccount } from "../../../hooks/useCurrentAccount";
import { AlertService } from "../../../services/Alert";
import Button from "../../../components/form-controls/Button";
import { useTranslation } from "react-i18next";
function AddTemplatePage() {

    const { t } = useTranslation();

    const { account } = useCurrentAccount();
    
    const navigate = useNavigate();

    const [step, setStep] = useState(1)

    const [step1Valid, setStep1Valid] = useState(false)
    const [step2Valid, setStep2Valid] = useState(false)
    
    const [stepForm1, setStepForm1] = useState(null)
    const [stepForm2, setStepForm2] = useState(null)
    const [isSubmitting, setIsSubmitting] = useState(false)
    
    const isValid = useMemo(() => {
        if(step === 1 && step1Valid) return step1Valid;
        
        return step2Valid;
    }, [step, step1Valid, step2Valid])

    const header = useMemo(() => {
        if(!stepForm2 || !stepForm2.header || stepForm2.header.format.value === 'none') {
            return null;
        }
        
        if(stepForm2.header.format.value === 'text') {
            return {
                type: 'HEADER',
                format: 'TEXT',
                text: stepForm2.header.text,
            };
        }
        if(stepForm2.header.format.value === 'media' && stepForm2.header.content.value === 'image') {
            return {
                type: 'HEADER',
                format: 'IMAGE',
                example: {
                    header_handle: [stepForm2.header.example.header_handle]
                },
                url: stepForm2.header.url
            };
        }
        if(stepForm2.header.format.value === 'media' && stepForm2.header.content.value === 'video') {
            return {
                type: 'HEADER',
                format: 'VIDEO',
                example: {
                    header_handle: [stepForm2.header.example.header_handle]
                },
                url: stepForm2.header.url
            };
        }
        if(stepForm2.header.format.value === 'media' && stepForm2.header.content.value === 'document') {
            return {
                type: 'HEADER',
                format: 'DOCUMENT',
                example: {
                    header_handle: [stepForm2.header.example.header_handle]
                },
                url: stepForm2.header.url
            };
        }

        return null;
    }, [stepForm2])
    
    const body = useMemo(() => {
        if(!stepForm2 || !stepForm2.body ) {
            return null;
        }
        
        let body_vars = []
        stepForm2.body.example.body_text.map( v => body_vars[v.key - 1] = v.value );

        let body = {
            ...stepForm2.body
        }

        if(body_vars.length) {
            body.example = {
                body_text: [ body_vars ]
            }
        } else {
            delete body.example
        }

        return body;

    }, [stepForm2])

    const footer = useMemo(() => {
        if(!stepForm2 || !stepForm2.footer || !stepForm2.footer.text ) {
            return null;
        }

        return {
            type: 'FOOTER',
            text: stepForm2.footer.text
        }
    }, [stepForm2])
    
    const buttons = useMemo(() => {
        
        if(!stepForm2 || !stepForm2.buttons || stepForm2.buttons.buttons.length === 0) {
            return null;
        }
        

        let buttons = []

        for (const btn of stepForm2.buttons.buttons) {
            if(btn.type === 'QUICK_REPLY')  {
                buttons.push({
                    type: 'QUICK_REPLY',
                    text: btn.text
                })
            }
            if(btn.type === 'URL' && btn.style === 'static')  {
                buttons.push({
                    type: 'URL',
                    text: btn.text,
                    url: btn.url
                })
            }
            if(btn.type === 'URL' && btn.style === 'dynamic')  {
                buttons.push({
                    type: 'URL',
                    text: btn.text,
                    url: `${btn.url}{{1}}`,
                    example: [ btn.example ]
                })
            }
            if(btn.type === 'QUICK_REPLY_DISABLE_MKT')  {
                buttons.push({
                    type: 'QUICK_REPLY',
                    text: btn.text
                })
            }
        }

        return {
            type: 'BUTTONS',
            buttons: buttons
        }

    }, [stepForm2])

    const save = async() => {
        try {
            setIsSubmitting(true)

            const btn = stepForm2.buttons.buttons.find( b => b.type === 'QUICK_REPLY_DISABLE_MKT');

            let data = {
                account_id: account.id,
                name: stepForm1.name,
                language: stepForm1.language.value,
                category: stepForm1.category,
                components: [],
                btn_blacklist: btn ? btn.text: null
            }
    
            if(header) {
                data.components.push(header)
            }
    
            if(body) {
                data.components.push(body)
            }
    
            if(footer) {
                data.components.push(footer)
            }
    
            if(buttons) {
                data.components.push(buttons)
            }

            console.log(data)
    
            await MetaService.saveTemplate(data)
    
            AlertService.toastSuccess('Se guardó correctamente la plantilla')
    
            navigate('/channels/templates')

        } catch (error) {
            AlertService.error('¡Error!', 'Ocurrió un error al guardar la plantilla, intenta más tarde.')
        } finally {
            setIsSubmitting(false)
        }
    }
    

    return (
        <>
            <Header />
            <Aside />
            <main id="content" role="main" className="main">
                <div className="content container-fluid">
                    <div className="page-header">
                        <div className="row align-items-center">
                            <div className="col-sm mb-2 mb-sm-0">
                                <nav aria-label="breadcrumb">
                                    <ol className="breadcrumb breadcrumb-no-gutter">
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" >{t("platform.platform-title")}</span></li>
                                        <li className="breadcrumb-item "><span className="breadcrumb-link" > {t("platform.channels.channels-title")}</span></li>
                                        <li className="breadcrumb-item active" aria-current="page">{t("platform.channels.whatsapp-b")}</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>

                        <div className="row align-items-center mt-3">
                            <div className="col-sm mb-2 mb-sm-0 d-flex align-items-center">
                                <button type="button" className="btn btn-soft-primary btn-icon me-3" onClick={() => navigate(-1)}>
                                    <i className="bi-chevron-left"></i>
                                </button>
                                <h2 className="page-header-title m-0 me-3 text-dark">{t("platform.channels.templates.add-template")}</h2>
                            </div>
                            <div className="col-sm-auto">
                                { step === 1 && <button className="btn btn-primary"  disabled={!isValid} onClick={() => setStep(2)}>{t("platform.channels.templates.btn-next")} <i className="bi-chevron-right ms-1"></i></button>}
                                { step === 2 && (
                                    <>
                                        <button className="btn btn-outline-primary me-3" onClick={() => setStep(1)}><i className="bi-chevron-left me-1"></i> {t("platform.channels.templates.btn-back")}</button>
                                        <Button className="btn btn-primary" isLoading={isSubmitting}  disabled={!isValid} onClick={save}>{t("platform.channels.templates.btn-save")}</Button>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className={ step === 1 ? '': 'd-none'}><Step1Partial onChange={(form) => setStepForm1(form)} isValidForm={setStep1Valid}  /></div>
                    <div className={ step === 2 ? '': 'd-none'}><Step2Partial onChange={(form) => setStepForm2(form)} isValidForm={setStep2Valid}  /></div>

                    <div className="row">
                        <div className="col">
                            <div className="d-flex my-5">
                                <div className="ms-auto">
                                { step === 1 && <button className="btn btn-primary"  disabled={!isValid} onClick={() => setStep(2)}>{t("platform.channels.templates.btn-next")} <i className="bi-chevron-right ms-1"></i></button>}
                                { step === 2 && (
                                    <>
                                        <button className="btn btn-outline-primary me-3" onClick={() => setStep(1)}><i className="bi-chevron-left me-1"></i> {t("platform.channels.templates.btn-back")}</button>
                                        <Button className="btn btn-primary" isLoading={isSubmitting}  disabled={!isValid} onClick={save}>{t("platform.channels.templates.btn-save")}</Button>
                                    </>
                                )}
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <Footer />
            </main>
        </>
    )
}
export default AddTemplatePage